import { useRef } from 'react'
import { VFieldFile } from '../../components/Fields'

export default function FormDVR() {
  const dvrInputRef = useRef<HTMLInputElement>(null)

  return (
    <div className="row mt-3 align-items-end">
      <div className="col-12 col-md-6">
        <VFieldFile name="dvr" label="DVR" ref={dvrInputRef} accept=".pdf" required />
      </div>
    </div>
  )
}
